import React from "react";

export default function EconomieTab() {
  return (
    <div className="diagoeau-panel">
      <h3>À construire prochainement</h3>
    </div>
  );
}
